<template>
  <div class="poster-index-wrap">
    <div class="poster-index">
      <img class="img-tag" src="@/assets/img/poster-img/poser-index-tag.png" alt="" />
      <img class="img-title" src="@/assets/img/poster-img/poser-index-title.png" alt="" />
      <div class="poster-index-btn" @click="clickHandle"><span class="iconfont iconfont-icon">&#xe616;</span>开始测试</div>
      <div class="poster-index-text">用政策补贴宝，企业补贴不再错过</div>
    </div>
    <van-popup v-model="showPopup" closeable round @close="closePopupHandle" position="bottom" :style="!isShowInput ? 'height: 65%' : 'height: 75%'">
      <div class="popup-box">
        <template v-if="isShowMobile">
          <div class="popup-title">开始评测</div>
          <div class="popup-title-brief">
            <img src="@/assets/img/poster-img/login-icon.png" alt="" />
            <p>资料及测评结果不对外公示</p>
          </div>
          <div class="phone-number">
            <img src="@/assets/img/poster-img/login-mobile.png" alt="" />
            <van-field placeholder="您的手机号" v-model="phone" maxlength="11" type="tel" />
          </div>
          <div class="agreement-div">
            <img :src="isAgree?imgChecked:imgUnchecked" alt="" @click="isAgree = !isAgree" />
            <p>
              在使用政策补贴宝功能前，请仔细阅读<router-link to="/agreement/laobanyun">《用户协议》</router-link>和<router-link
                to="/agreement/privacy"
                >《隐私协议》</router-link
              >并勾选同意
            </p>
          </div>
          <div class="phone-btn" @click="goSendCode">
            开始评测
          </div>
        </template>
        <template v-else>
          <div class="popup-title">输入短信验证码</div>
          <div class="send-mobile">
            已发送验证码至<span>{{ phone }}</span>
          </div>
          <div class="password-box">
            <div class="input-box" id="inputBox">
              <!-- 伪装的input -->
              <div v-for="(item, index) in inputLength" :key="item">
                <div class="input" @click="focusInput">
                  <div class="show">{{ currentValue.length >= index + 1 ? currentValue[index] : '' }}</div>
                </div>
              </div>
            </div>
            <div v-if="time > 0" :class="['resend-code', time > 0 ? 'disable' : '']">
              重新发送<span class="time-code" v-if="time > 0">({{ time }}s)</span>
            </div>
            <div v-else-if="time === 0" class="resend-code">未收到验证码？可以 <span class="time-code-active" @click="getCode">重新发送</span></div>
            <!-- 隐藏的输入框 -->
            <van-field
              ref="input"
              @blur="blurHandle"
              v-model="currentValue"
              @input="_setCurrentValue"
              :maxlength="inputLength"
              type="digit"
              label=""
            />
          </div>
        </template>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { loginSendCode, loginApi } from '@/api/api_login.js'
import WX from 'weixin-js-sdk'
export default {
  data() {
    return {
      showPopup: false,
      isShowMobile: true,
      phone: '',
      currentValue: '',
      inputLength: 6,
      inputFocus: false,
      time: null,
      isShowInput: false,
      loginChannel: null,
      isAgree: false, // 协议是否勾选
      imgChecked: require('@/assets/img/poster-img/checked.png'),
      imgUnchecked: require('@/assets/img/poster-img/uncheck.png'),
    }
  },
  mounted() {
    this.loginChannel = this.$route.query.loginChannel || localStorage.getItem('loginChannel') || '34'
  },
  methods: {
    closePopupHandle() {
      this.isShowMobile = true
      this.showPopup = false
    },
    goSendCode() {
      if (!this.isAgree) {
        this.$toast('请同意隐私政策')
        return false
      }
      if (!this.phone) {
        this.$toast('请输入手机号')
        return false
      } else if (this.phone.length < 11) {
        this.$toast('手机号格式不正确')
        return false
      }
      this.isShowMobile = false
      this.$nextTick(() => {
        this.$refs.input.focus()
      })
      this.getCode()
    },
    clickHandle() {
      this.showPopup = true
    },
    focusInput() {
      this.$nextTick(() => {
        this.$refs.input.focus()
        this.isShowInput = true
      })
    },
    blurHandle() {
      this.isShowInput = false
    },
    getCode() {
      let params = {
        mobile: this.phone,
        smsType: 'LOGIN',
      }
      loginSendCode(params).then(res => {
        if (res.ok === true) {
          this.$toast('验证码发送成功')
          this.sendCode()
        } else {
          this.time = 0
          this.$toast(res.msg)
        }
      })
    },
    // 设置当前的值
    _setCurrentValue() {
      // 在此处判断满6（inputLength）位，把值返回给上级父组件或页面
      let currentValue = this.currentValue
      // 改变时，派发一个事件，如果父组件或页面中需要实时获取改变后的值，可以监听这个事件。
      if (currentValue.length === this.inputLength) {
        this.login()
      }
    },
    sendCode() {
      var currentTime = 60
      var interval = setInterval(() => {
        this.time = currentTime
        currentTime--
        if (currentTime <= 0) {
          clearInterval(interval)
          this.time = 0
        }
      }, 1000)
    },
    login() {
      let that = this
      let { shareId } = this.$route.query
      let params = {
        mobile: this.phone,
        code: this.currentValue, //this.currentValue,
      }
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        WX.miniProgram.getEnv(res => {
          if (res.miniprogram) {
            params.loginChannel = '89' //在小程序内
          } else {
            params.loginChannel = that.loginChannel //不在小程序内
          }
        })
      } else {
        //不在微信里
        params.loginChannel = that.loginChannel
      }
      params.shareId = shareId
      loginApi(params).then(res => {
        if (res.ok === true) {
          localStorage.setItem('token', res.data.token)
          localStorage.setItem('userId', res.data.userId)
          this.$store.commit('SET_LOGIN_INFO', res.data)
          this.$router.push({
            path: '/specialposternext',
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.poster-index-wrap {
  background: #e6f0fe;
  height: 100vh;
  width: 100%;
  .popup-box {
    padding: 40px 30px 0;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 16px;
    .send-mobile {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 16px;
      padding-top: 10px;
      span {
        color: #398dff;
      }
    }
    .input-box {
      margin: 30px 0 0;
      display: flex;
      justify-content: space-between;
    }
    .password-box {
      /deep/ .van-cell {
        opacity: 0;
      }
    }
    .input {
      width: 50px;
      height: 58px;
      border-radius: 5px;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      font-size: 33px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 58px;
      margin-right: 4px;
    }
    .input:last-child {
      margin-right: 0px;
    }
    .hidden-input {
      opacity: 0;
    }
    .resend-code {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 12px;
      padding-top: 23px;
      text-align: left;
    }
    .disable {
      pointer-events: none;
      text-decoration: none;
    }
    .time-code {
      margin-left: 10px;
    }
    .time-code-active {
      color: #398dff;
    }
    .popup-title-brief {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(57, 141, 255, 1);
      line-height: 16px;
      padding-top: 11px;
      display: flex;
      align-items: center;
      img {
        width: 11px;
        height: 13px;
      }
      p {
        padding-left: 5px;
      }
    }
    .phone-number {
      border-bottom: 1px solid #dddddd;
      padding: 72px 0 10px;
      text-align: left;
      display: flex;
      align-items: center;
      img {
        width: 12px;
        height: 17px;
        display: inline-block;
      }
      /deep/ .van-cell {
        font-size: 16px;
        line-height: 28px;
        margin: 0;
        padding: 0px 10px;
      }
      /deep/ .van-cell::after {
        border: 0;
      }
      /deep/ .van-field__control {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333;
        margin: 0;
        padding: 0;
      }
      .clear-style {
        color: #ddd;
      }
    }
    .phone-btn {
      width: 315px;
      height: 44px;
      background: rgba(57, 141, 255, 1);
      box-shadow: 0px 5px 10px 0px rgba(57, 141, 255, 0.3);
      border-radius: 22px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 44px;
      text-align: center;
      margin-top: 30px;
    }
  }
  .poster-index {
    background: url('../../assets/img/poster-img/poser-index-bg.png') center center no-repeat;
    background-size: cover;
    height: 100vh;
    padding-top: 41px;
    position: relative;
    .img-tag {
      display: block;
      width: 148px;
      height: 22px;
      margin: 0 auto 0;
    }
    .img-title {
      width: 270px;
      height: 92px;
      display: block;
      margin: 22px auto 0;
    }
    .poster-index-text {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 20px;
      text-align: center;
      padding-top: 10px;
      position: absolute;
      bottom: 36px;
      left: 0;
      right: 0;
    }
    .poster-index-btn {
      width: 335px;
      height: 45px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px -1px 3px 0px rgba(255, 255, 255, 0.5), 0px 3px 8px 0px rgba(191, 105, 58, 0.13);
      border-radius: 28px;
      margin: 5px auto 0;
      text-align: center;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(72, 145, 254, 1);
      line-height: 45px;
      margin-top: 345px;
      position: absolute;
      bottom: 66px;
      left: 50%;
      transform: translateX(-50%);
      .iconfont-icon {
        display: inline-block;
        padding-right: 5px;
      }
    }
  }
}
</style>
